import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";

import {changeCartFeature} from "../../../actions/actionFunctions";
import WithMaterialsWizardFooterCommon from "./withMaterialsWizardFooterCommon";
import Analytics from "../../../analytics";
import {ROUTES} from "../../../routes";


const MaterialsWizardFooterSelectButton = (props) => {

  const {advancedQuotingSearchItem, history, selectionFeatureInfo, changeCartFeature, activeFeature, quantityIsZero,
    selectionInfoQuantity, handleAddCartItemClick} = props;

  const currentActiveFeature = selectionFeatureInfo || activeFeature;
  const disabled = !currentActiveFeature;

  const updateCartAndGoBack = (analyticsLabel) => {
    Analytics.sendClickEvent(analyticsLabel);
    history.push(ROUTES.shoppingcart);
  };

  const handleSelectItem = () => {
    if (disabled) {
      return false
    }
    const quantity = selectionFeatureInfo
      ? selectionInfoQuantity || 1
      : advancedQuotingSearchItem ? advancedQuotingSearchItem.quantity : 1;
    if (quantityIsZero()) {
      return false;
    }
    if (advancedQuotingSearchItem) {
      // if (this.props.advancedQuotingSearchItem && activeFeature
      //   && (this.props.advancedQuotingSearchItem.cartFeature.dbFeature.id !== activeFeature.dbFeature.id)) { // removed this logic, cause we always need to remove old item
      changeCartFeature(Object.assign({}, advancedQuotingSearchItem, {
        quantity,
        cartFeature: currentActiveFeature
      }));
      updateCartAndGoBack('select-advanced-quoting-item');
    } else {
      handleAddCartItemClick(currentActiveFeature, quantity, 'select-advanced-quoting-item');
      history.push(ROUTES.shoppingcart);
    }
  };

  return (
    <button className={"selection-footer-buttons__cart ui-button2"
      + (disabled ? " ui-button2--gray" : " ui-button3--green pulsating--green")}
            disabled={disabled}
            onClick={handleSelectItem}>
      <FormattedMessage id="quotingTool.footer.selectItem"/>
    </button>
  )

};

MaterialsWizardFooterSelectButton.propTypes = {
  handleAddCartItemClick: PropTypes.func
}

const mapStateToProps = (store) => {
  const {selectionFeatureInfo, activeFeature, selectionInfoQuantity} = store.selectionState;
  const {advancedQuotingSearchItem} = store.advancedQuotingState;

  return {
    selectionFeatureInfo,
    advancedQuotingSearchItem,
    activeFeature,
    selectionInfoQuantity,
  };
};

const mapDispatchToProps = {
  changeCartFeature,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(
    WithMaterialsWizardFooterCommon(MaterialsWizardFooterSelectButton)
  )
)
